import { Box, Button, Callout, Dialog, Intent, Text } from "@blasterjs/core";
import React from "react";

import { DialogBody, DialogFooter, DialogHeader } from "../components/DialogLayout";
import ReasonForChange from "../components/ReasonForChange";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  closeRemoveHoldCaseDialog,
  caseRemoveHold,
  setRemoveHoldCaseForm
} from "../slices/removeHoldCaseDialog";
import { casesFetch } from "../slices/cases";

const removeHoldCaseDialog = () => {
  const dispatch = useAppDispatch();
  const removeHoldCaseDialog = useAppSelector(state => state.removeHoldCaseDialog);

  const closeDialog = () => {
    dispatch(closeRemoveHoldCaseDialog());
  };

  const onConfirm = () => {
    removeHoldCaseDialog.isOpen &&
      dispatch(caseRemoveHold()).then(() => {
        if (removeHoldCaseDialog.case.data.case.id) {
          dispatch(casesFetch(removeHoldCaseDialog.case.data.case.studyId));
        }
      });
  };

  const onChangeReasonForChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    removeHoldCaseDialog.isOpen &&
      dispatch(
        setRemoveHoldCaseForm({
          ...removeHoldCaseDialog.case.data,
          reasonForChange: e.target.value
        })
      );
  };

  const errorText =
    removeHoldCaseDialog.isOpen && "errorMessage" in removeHoldCaseDialog.case ? (
      <Box mb="2">
        <Callout intent={Intent.DANGER}>
          <Text>{removeHoldCaseDialog.case.errorMessage}</Text>
        </Callout>
      </Box>
    ) : null;

  const confirmDisabled = !(
    removeHoldCaseDialog.isOpen && removeHoldCaseDialog.case.data.reasonForChange
  );
  return removeHoldCaseDialog.isOpen ? (
    <Dialog isOpen={removeHoldCaseDialog.isOpen} onRequestClose={closeDialog} appElementId="root">
      <DialogHeader title="Remove Hold" closeDialog={closeDialog} />
      <DialogBody>
        {errorText}
        <Box>
          <Box style={{ width: "100%" }}>
            Are you sure you want to remove the hold on the following case?
          </Box>
          <Box style={{ width: "100%" }}>The hold will be removed from all images in the case.</Box>
          <br />
          <br />
          {removeHoldCaseDialog.case.data.case.histoProcedureId && (
            <>
              Histo Procedure ID: <b>{removeHoldCaseDialog.case.data.case.histoProcedureId}</b>
              <br />
            </>
          )}
          {removeHoldCaseDialog.case.data.case.procId && (
            <>
              Endo Procedure ID: <b>{removeHoldCaseDialog.case.data.case.procId}</b>
            </>
          )}
        </Box>
        <Box style={{ marginTop: 12 }}>
          Reason for Change*
          <ReasonForChange
            rkey="archiveCase_reason"
            value={
              (removeHoldCaseDialog.isOpen && removeHoldCaseDialog.case.data.reasonForChange) || ""
            }
            onChange={onChangeReasonForChange}
          />
        </Box>
      </DialogBody>
      <DialogFooter>
        <Button
          onClick={onConfirm}
          disabled={confirmDisabled}
          appearance="prominent"
          intent="danger"
        >
          Confirm
        </Button>
        <Button onClick={closeDialog}>Cancel</Button>
      </DialogFooter>
    </Dialog>
  ) : null;
};

export default removeHoldCaseDialog;
